/* eslint-disable */

import request from '@/utils/request'

export function getUserGroupApi(query) {
  return request({
    url: '/config-service/v1/user-group/user-group',
    method: 'get',
    params: query
  })
}

export function addUserGroupApi(query) {
  return request({
    url: '/config-service/v1/user-group/user-group',
    method: 'post',
    params: query
  })
}

export function updateUserGroupApi(query) {
  return request({
    url: '/config-service/v1/user-group/user-group',
    method: 'put',
    data: query
  })
}
export function updateUserGroupMenuApi(param, query) {
  return request({
    url: '/config-service/v1/user-group/set-user-group-menu',
    method: 'post',
    params: param,
    data: query
  })
}
export function deleteUserGroupApi(query) {
  return request({
    url: '/config-service/v1/user-group/user-group',
    method: 'delete',
    data: query
  })
}
